<button type="button" *ngIf="isParamDestEnabled" (click)="backToPreviousPage()" [ngbPopover]="backbuttonPopoverText"
  triggers="hover" placement="auto" container="body" class="btn btn-outline-primary btn-circle mr-4"><i
    class="link-icon feather icon-arrow-left"></i>
</button>